import { Banner } from '../context/banner-context';
import { BANNER_HEIGHTS } from '../config';

const getBannerHeight = (isSmall: boolean, banners: Banner[]) => {
	if (isSmall) {
		const isShortLayoutForced = !!banners.find(i => i.mobileLayoutType === 'SHORT');

		return isShortLayoutForced ? BANNER_HEIGHTS.mobileShort : BANNER_HEIGHTS.mobile;
	}

	return BANNER_HEIGHTS.desktop;
};

export default getBannerHeight;
